module.exports = __webpack_public_path__ + "img/card-gold.00ae1b85.svg";